import React from 'react';
import { CellProps } from 'react-table';
import { useTranslation } from 'react-i18next';

import { Button, DataTableColumns, VisuallyHidden } from '@tq/ui-components';

import { useNavigate } from 'hooks';
import { Team } from 'types';

export const useManageTeamColumns = (): DataTableColumns<Team>[] => {
  const { t } = useTranslation('manage_teams');
  const { navigateToTeam } = useNavigate();

  return [
    {
      accessor: 'teamName',
      disableSortBy: false,
      Header: () => t('team_name', 'Team name'),
      width: 300,
    },
    {
      accessor: 'backOfficeCode',
      disableSortBy: false,
      Header: () => t('back_office_code', 'Back Office code'),
      width: 200,
    },
    {
      accessor: 'email',
      disableSortBy: false,
      Header: () => t('team_email', 'Team email'),
      width: 'auto',
    },
    {
      accessor: 'organisationName',
      disableSortBy: false,
      Header: () => t('organisation', 'Organisation'),
      width: 300,
    },
    {
      accessor: 'msgDetail',
      Cell: ({ row: { original } }: CellProps<Team>) => (
        <Button
          variant='secondary'
          size='xs'
          onClick={() => navigateToTeam(original.organisationId)}
        >
          {t('manage', 'Manage')}
        </Button>
      ),
      Header: () => <VisuallyHidden>{t('manage_header', 'Manage')}</VisuallyHidden>,
      width: 100,
      disableSortBy: true,
    },
  ];
};
